import { Stack } from '@mantine/core';
import { EmploymentContractCard } from './ServiceCards/EmploymentContractCard';
// import AvailabilityFinderCard from './ServiceCards/AvailabilityFinderCard';
import AvailabilitySettingsCard from './ServiceCards/AvailabilitySettingsCard';
import ExceptionalEventsCard from './ServiceCards/ExceptionalEventsCard';
import { ApprovedTimeOffCard } from './ServiceCards/ApprovedTimeOffCard';
import { TimeOffToBeApprovedCard } from './ServiceCards/TimeOffToBeApprovedCard';

export default function EmployeeServicesSidebar() {
  return (
    <div>
      <Stack gap="sm">
        <EmploymentContractCard />
        {/* <AvailabilityFinderCard /> */}
        <AvailabilitySettingsCard />
        <ExceptionalEventsCard />

        {/* TODO */}
        <ApprovedTimeOffCard />
        <TimeOffToBeApprovedCard/>
        {/* <AvailabilityLegendCard /> */}
      </Stack>
    </div>
  );
}
